import { render } from "./Sidebar.vue?vue&type=template&id=678c998e&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=678c998e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-678c998e"

export default script